import { gql } from '@apollo/client'

export interface QueryVars {
  customerId: string
  subjectId: string
}

export interface SubjectChangeActivityModel {
  id: string
  applicationId: string
  customerId: string
  type: string
  category: string
  source: SubjectActivitySourceModel
  changes: SubjectActivityChangeModel[]
  createdAt: string
  author?: SubjectActivityAuthorModel | null
}

export interface SubjectActivityChangeModel {
  fieldName: string
  path: string
  oldValue: string | null
  newValue: string | null
}

export interface SubjectActivityAuthorModel {
  type: string
  id: string | null
  name: string | null
  email: string | null
}

export interface SubjectActivitySourceModel {
  eventName: string
  metadata: SubjectActivitySourceMetadataModel
}

export interface SubjectActivitySourceMetadataModel {
  activityType: string
  section: string
}

export interface Response {
  getSubjectChangeActivities: SubjectChangeActivityModel[]
}

const query = gql`
  query ($customerId: String, $subjectId: String) {
    getSubjectChangeActivities(customerId: $customerId, subjectId: $subjectId) {
      id
      subjectId
      applicationId
      customerId
      type
      category
      createdAt
      source {
        eventName
        metadata {
          activityType
          section
        }
      }
      changes {
        fieldName
        path
        oldValue
        newValue
      }
      author {
        type
        id
        name
        email
      }
    }
  }
`

export default query
